import type { AcriAnswer } from '@/components/OnboardingQuestionPage'
import OnboardingQuestionPage from '@/components/OnboardingQuestionPage'

const answers: AcriAnswer[] = [
  {
    emoji: '🇺🇸',
    title: 'pages.onboarding.location.us',
    value: 'united-states',
  },
  {
    emoji: '🇬🇧',
    title: 'pages.onboarding.location.uk',
    value: 'united-kingdom',
  },
  { emoji: '🇩🇪', title: 'pages.onboarding.location.de', value: 'germany' },
  { emoji: '🇫🇷', title: 'pages.onboarding.location.fr', value: 'france' },
  { emoji: '🇦🇺', title: 'pages.onboarding.location.au', value: 'australia' },
  { emoji: '🇵🇱', title: 'pages.onboarding.location.pl', value: 'poland' },
  { emoji: '🇳🇱', title: 'pages.onboarding.location.nl', value: 'netherlands' },
  { emoji: '🇨🇦', title: 'pages.onboarding.location.ca', value: 'canada' },
  { emoji: '🇸🇪', title: 'pages.onboarding.location.se', value: 'sweden' },
  { emoji: '🇮🇳', title: 'pages.onboarding.location.in', value: 'india' },
  { emoji: '🇸🇬', title: 'pages.onboarding.location.sg', value: 'singapore' },
  { emoji: '🇯🇵', title: 'pages.onboarding.location.jp', value: 'japan' },
]

export default function LocationPage() {
  return (
    <OnboardingQuestionPage
      answers={answers}
      title="pages.onboarding.location.title"
      subtitle="pages.onboarding.location.subtitle"
      layout="grid"
    />
  )
}
